export default __webpack_public_path__ + "static/california_rose-cdd8262bb1c794626e27b0ec807311c8.png";